import { render, staticRenderFns } from "./ShippingExcels.vue?vue&type=template&id=4fa7d9f4&scoped=true&"
import script from "./ShippingExcels.vue?vue&type=script&lang=js&"
export * from "./ShippingExcels.vue?vue&type=script&lang=js&"
import style0 from "./ShippingExcels.vue?vue&type=style&index=0&id=4fa7d9f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa7d9f4",
  null
  
)

export default component.exports